import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ChartEmpty.module.scss';

export interface ChartEmptyProps {
  title: string;
  description?: string;
}

export const ChartEmpty = ({
  title,
  description,
  ...rest
}: ChartEmptyProps) => {
  const { t } = useTranslation('chart');
  return (
    <div className={styles.chartEmptyRoot} data-testid="chart-empty" {...rest}>
      <div className={styles.imageWrapper}>
        <img
          src="/app/static/images/illustrations/empty.svg"
          width={80}
          height={80}
          alt={t('chart:empty.imgAlt')}
        />
      </div>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description} </div>}
    </div>
  );
};
